import { jsx as o } from "react/jsx-runtime";
import { memo as m } from "react";
import { ValueDescription as p, TooltipContent as c } from "@biron-data/react-components";
import { a as s } from "../index-e062cb03-BJ_Yd14E.js";
const D = m(function({
  title: i,
  description: t,
  code: r,
  getMoreInformationLink: e
}) {
  const n = e(r);
  return /* @__PURE__ */ o(p, { children: /* @__PURE__ */ o(c, { description: t, Icon: s, title: i, nature: "view", viewLink: n }) });
});
export {
  D as default
};
//# sourceMappingURL=ViewDescription.js.map
